import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '1 - 5x7, 4 - 2x3',
  imageCount: 5,
  displayGroup: 'DG_5X7_WALLET',
  calc: (height) => {
    const p1Width = height / ASPECT_RATIO / 2;
    const p1Height = height / 2;
    const p5Width = height / ASPECT_RATIO;
    const p5Height = height;

    return {
      gridTemplate: `
        'p1 p2 p5' ${p1Height}px
        'p3 p4 p5' ${p1Height}px
        / ${p1Width}px ${p1Width}px ${p5Width}px`,
      photos: [
        ...gridPhotos(1, 4, p1Width, p1Height),
        {
          gridArea: 'p5',
          width: p5Width,
          height: p5Height
        }
      ]
    };
  }
};
